import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

export default function GoogleReviewsWidget() {
	const { i18n } = useTranslation();

	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://elfsightcdn.com/platform.js';
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);

		return () => {
			if (document.body.contains(script)) {
				document.body.removeChild(script);
			}
		};
	}, []);

	const appId = i18n.language === 'en' ? '603eed52-fa64-4dea-a216-806caa1d6672' : '221e16f1-057c-41e0-8b74-2c0f202f73fa';

	return (
		<Box
			className='google-reviews-widget-container'
			style={{
				width: '100%',
				overflow: 'hidden',
				padding: '20px 0',
			}}>
			<div
				className={`elfsight-app-${appId}`}
				data-elfsight-app-lazy
			/>
		</Box>
	);
}
